import { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "configureStore";
import { Button, InlineStack, Banner } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { sendEmailWithAttachment } from "services/customers.service";
import { fetchCustomer } from "containers/customer/customer-container.slice";
import { setDestroy, setIsModalxOpen } from "components/modalx/modalx.slice";
import { useParams } from "react-router-dom";
import { fetchOrderDetails } from "containers/order-view-container/order-container.slice";

interface ConfirmModalProps {
  companyId: string;
  customerId: string;
  fileId: string;
  // Runs after the e-mail was sent, e.g. so a list outside redux can refresh.
  onSuccess?: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  companyId,
  customerId,
  fileId,
  onSuccess,
}) => {
  const dispatch: AppDispatch = useDispatch();
  const { orderId } = useParams();
  const { t } = useTranslation();
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errMsg, setErrMsg] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSendEmailWithAttachment = async () => {
    try {
      setIsLoading(true);
      const formData = {
        fileId,
      };
      await sendEmailWithAttachment(companyId, customerId, formData);
      dispatch(fetchCustomer({ customerId, companyId: companyId! }));
      if (orderId && companyId)
        dispatch(fetchOrderDetails({ companyId, orderId }));
      onSuccess?.();
      setSuccessMessage(t("email_sent_successfully"));
      setTimeout(() => {
        closeModal();
      }, 1000);
    } catch (e) {
      setErrMsg("error");
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    dispatch(setIsModalxOpen(false));
    dispatch(setDestroy());
  };

  return (
    <>
      <div className="form-warnings">
        {errMsg && (
          <div>
            <Banner tone="critical">{t(errMsg)}</Banner>
          </div>
        )}
        {successMessage && (
          <div>
            <Banner tone="info">{t(successMessage)}</Banner>
          </div>
        )}
      </div>
      <h1 style={{ textAlign: "center" }}>
        {t("Are_you_sure_you_want_to_send_document_to_customer_by_email")}
      </h1>
      <br />
      <InlineStack align="space-between">
        <Button onClick={handleSendEmailWithAttachment} loading={isLoading}>
          {t("Yes")}
        </Button>

        <Button onClick={closeModal}>{t("No")}</Button>
      </InlineStack>
    </>
  );
};

export default ConfirmModal;
